"use client";

import { MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
const hotels = [{
  id: 1,
  name: "Parador de Ferrol",
  address: "Praza do Contralmirante Azarola Gresillón, 15401 Ferrol, A Coruña",
  phone: "+34 981 35 67 20",
  mapLink: "https://maps.app.goo.gl/jnHswaLNkouMkmRk9",
  buttonLabel: "Cómo llegar"
}, {
  id: 2,
  name: "Hotel Almirante",
  address: "C. de María, 2, 15402 Ferrol, A Coruña",
  phone: "+34 981 33 30 73",
  mapLink: "https://maps.app.goo.gl/oAAyKBRazR9Ka5SSA",
  buttonLabel: "Cómo llegar"
}, {
  id: 3,
  name: "Hotel Valencia ",
  address: "Est. de Catabois, 390, 15405 Ferrol, A Coruña",
  phone: "+34 981 37 03 52",
  mapLink: "https://maps.app.goo.gl/SryojbWwnqigqxNS9",
  buttonLabel: "Cómo llegar"
}];
function Accommodations() {
  return <section id="alojamientos" className="bg-background text-foreground py-[var(--space-4xl)]">
      <div className="container">
        <div className="mt-[var(--space-3xl)]">
          <h2 className="font-display text-[2.125rem] font-semibold leading-[1.3] text-foreground mb-[var(--space-2xl)] text-center">
            Alojamientos Recomendados
          </h2>

          <p className="text-base leading-[1.5] text-foreground text-center mb-[var(--space-xl)] max-w-3xl mx-auto">
            Si necesitáis alojamiento para el fin de semana de la boda, aquí os
            dejamos algunas recomendaciones de hoteles cercanos.
            <div>Hemos seleccionado opciones bien ubicadas y con distintas categorías para que podáis elegir la que mejor se adapte a vosotros.</div>
            <div>Os recomendamos reservar con antelación.</div>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[var(--space-xl)]">
            {hotels.map((hotel, i) => <div key={hotel.id} data-index={i} className="bg-muted-light-background rounded-[var(--radius-md)] shadow-soft p-[var(--space-xl)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
                <h3 className="font-display text-[2.125rem] font-semibold leading-[1.4] text-foreground mb-[var(--space-md)]">
                  {hotel.name}
                </h3>

                <div className="flex items-start gap-[var(--space-sm)] mb-[var(--space-md)]">
                  <MapPin className="size-5 text-foreground shrink-0 mt-0.5" />
                  <p className="text-base leading-[1.5] text-foreground">
                    {hotel.address}
                  </p>
                </div>

                <div className="flex items-center gap-[var(--space-sm)] mb-[var(--space-lg)]">
                  <Phone className="size-5 text-foreground shrink-0" />
                  <p className="text-base leading-[1.5] text-foreground">
                    {hotel.phone}
                  </p>
                </div>

                <Link to={hotel.mapLink} newTab className="btn-primary gap-2 w-full">
                  <MapPin className="size-5" />
                  <span>{hotel.buttonLabel}</span>
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}
export default Accommodations;